import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Table } from 'antd';

import { uniqueId, showMessage } from '../../../../../../../data/config/utils';
import TableCellAction from '../../../../../components/tablecellaction';
import EditablePageHeader from '../../../../../../pagecontainer/components/editablepageheader';
import AddInputItem from '../../../../../../../components/form/addinputItem';
import ModalFooter from '../../../../../../../components/modalfooter';

class HierarchicalEntity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            new_child_entity: null,
        };
        this.childrenTableColumns = [
            {
                title: "Children",
                key: "name",
                dataIndex: "name",
                render: (text) => {
                    return (
                        <div className="ori-flex-row ">
                            <div className="ori-bg-default ori-lr-pad-10 ori-tb-pad-3 ori-border-radius-4">{text}</div>
                        </div>
                    )
                }
            },
            {
                key: "clickAction",
                dataIndex: "clickAction",
                align: "right",
                render: (text, record, index) => {
                    return (
                        <TableCellAction align_right show_delete delete_popconfirm_title="Are you sure delete this child?" handleDeleteClick={() => this.deleteChildEntity(index)} />
                    );
                }
            },
        ];
        this.utteranceTableColumns = [
            {
                title: "Labeled Utterances",
                key: "text",
                dataIndex: "text",
                render: (text) => {
                    return (
                        <div className="ori-flex-row ">
                            <div className="ori-bg-default ori-lr-pad-10 ori-tb-pad-3 ori-border-radius-4">{text}</div>
                        </div>
                    )
                }
            },
        ];
    }

    deleteChildEntity = (index) => {
        const path = `active_entity_data.entity.children.${index}`;
        this.props.actions.deleteEntityState(path);
    };

    onChangeNewChildEntity = e => {
        this.setState({ 
            new_child_entity: e.target.value 
        });
    }

    addChildEntity = () => {
        const { actions, entity_details } = this.props;
        const { new_child_entity } = this.state;
        if (new_child_entity && new_child_entity.trim().length > 0) {
            const new_child = { name: new_child_entity.trim() };
            if(entity_details.active_entity_data.entity.children){
                let index = -1;
                index = entity_details.active_entity_data.entity.children.findIndex((child)=>{return (child.name === new_child.name)});
                if(index === -1){
                    const payload = [new_child,...entity_details.active_entity_data.entity.children];
                    actions.updateEntityState(payload,'active_entity_data.entity.children');
                } else {
                    showMessage('warning',  `${new_child.name} already exist.`)
                }
            } else {
                const payload = [new_child];
                actions.updateEntityState(payload,'active_entity_data.entity.children');
            }
            this.setState({ new_child_entity: null });
        }
    };

    addChildKeyDown = e => {
        if (e.keyCode === 13 ) {
            this.addChildEntity();
        }
    };

    render() {
        const { page_details, entity_details, actions, goToEntitiesPage, updateEntity } = this.props;
        const { new_child_entity } = this.state;
        const mobile = page_details.device_data.screen_width < 768;

        return (
            <Row>
                <EditablePageHeader editable title={entity_details.active_entity_data.entity.name} onChangeTitle={(e) => actions.updateEntityState(e.target.value, 'active_entity_data.entity.name')} />
                <Col xs={24} sm={{ span: 18, offset: 3 }} md={{ span: 16, offset: 4 }} className="ori-lr-pad-10 orii-b-pad-10">
                    <AddInputItem size="large" container_class="ori-t-pad-5" placeholder="Add new child" show_add_btn={new_child_entity && new_child_entity.trim().length > 0} onChange={this.onChangeNewChildEntity} value={new_child_entity} onKeyDown={this.addChildKeyDown} onClickBtn={this.addChildEntity} />
                    <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 600 }} size={mobile ? "small" : "middle"} rowKey={uniqueId} columns={this.childrenTableColumns} dataSource={entity_details.active_entity_data.entity.children} />
                    <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 600 }} size={mobile ? "small" : "middle"} rowKey={uniqueId} columns={this.utteranceTableColumns} dataSource={entity_details.active_entity_data.utterances} />
                    <ModalFooter button_ok_text={entity_details.loaders.entity_updating ? 'Saving' : 'Save'} loading={entity_details.loaders.entity_updating} handleOkClick={updateEntity} handleCancelClick={goToEntitiesPage} capsule_button />
                </Col>
            </Row>
        );

    }
}

HierarchicalEntity.propTypes = {
    actions: PropTypes.object,
    page_details: PropTypes.object,
    entity_details: PropTypes.object,
    match: PropTypes.object,
    goToEntitiesPage: PropTypes.func,
    updateEntity: PropTypes.func,
};

export default HierarchicalEntity;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/entities/editentity/hierarchicalentity/index.js